import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import request from '../../../request';

export default class DeleteUser extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor() {
    super();
    this.state = {};
  }

  async delete() {
    let { location } = this.props;
    this.setState({ loading: true });

    try {
      await request({
        url: `settings/users/${location.state.user.id}`,
        method: 'DELETE',
      });
      if (!location.state.company_id)
        this.context.router.history.push(`/settings`);
      this.context.router.history.push(
        `/settings/companies/${location.state.company_id}/users`
      );
    } catch (error) {
      this.setState({ error: error.message, loading: false });
    }
  }

  render() {
    let { location } = this.props;
    let { loading, error } = this.state;

    return (
      <div id="edit" className="edge" style={{ opacity: loading ? 0.5 : 1 }}>
        <h5 className="heading">Delete "{location.state.user.first_name}"</h5>
        {error ? <p className="error">{error}</p> : null}
        <p>Are you sure you want to remove this user? You can't undo this.</p>
        <div id="dashboard">
          <div className="options">
            <button
              id="confirm"
              className="action primary"
              type="submit"
              onClick={() => this.delete()}
            >
              Confirm
            </button>
            <Link
              className="action"
              to={`/settings/companies/${location.state.company_id}/users`}
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/settings/users/delete.js